export enum TrainingType {
  Internal,
  External,
}

export const TrainingTypeOptions = [
  { id: TrainingType.Internal, name: 'Internal' },
  { id: TrainingType.External, name: 'External' },
];
